"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLocalizedStrings;

var _useWebChatAPIContext2 = _interopRequireDefault(require("./useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useLocalizedStrings() {
  var _useWebChatAPIContext = (0, _useWebChatAPIContext2.default)(),
      localizedStrings = _useWebChatAPIContext.localizedStrings;

  return localizedStrings;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VMb2NhbGl6ZWRTdHJpbmdzIiwidXNlV2ViQ2hhdEFQSUNvbnRleHQiLCJsb2NhbGl6ZWRTdHJpbmdzIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaG9va3MvaW50ZXJuYWwvdXNlTG9jYWxpemVkU3RyaW5ncy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZUxvY2FsaXplZFN0cmluZ3MoKSB7XG4gIGNvbnN0IHsgbG9jYWxpemVkU3RyaW5ncyB9ID0gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKTtcblxuICByZXR1cm4gbG9jYWxpemVkU3RyaW5ncztcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBRWUsU0FBU0EsbUJBQVQsR0FBK0I7RUFDNUMsNEJBQTZCLElBQUFDLDhCQUFBLEdBQTdCO0VBQUEsSUFBUUMsZ0JBQVIseUJBQVFBLGdCQUFSOztFQUVBLE9BQU9BLGdCQUFQO0FBQ0QifQ==